import {Component, HostListener, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {StateStorageService} from '../../service/state-storage.service';
import {MatDialogRef} from '@angular/material/dialog';
import {AuthenticationService, NotificationService} from '@enerbim/commons-lib';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
    selector: 'bim-login-dialog',
    templateUrl: './login-dialog.component.html',
    styleUrls: ['./login-dialog.scss']
})
export class LoginDialogComponent implements OnInit {

    loginForm: FormGroup;
    rememberMe: boolean;

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.login();
            event.preventDefault();
        }
    }

    constructor(
        private dialogRef: MatDialogRef<LoginDialogComponent>,
        private authenticationService: AuthenticationService,
        private stateStorageService: StateStorageService,
        private notificationService: NotificationService,
        private router: Router,
        private fb: FormBuilder,
    ) {
    }

    ngOnInit() {
        this.rememberMe = true;
        this.loginForm = this.fb.group({
            email: ['', Validators.required],
            password: ['', [Validators.required, Validators.minLength(4)]]
        });
    }

    login() {
        if (!this.loginForm.valid) {
            return;
        }
        this.notificationService.notify('Connexion en cours...');
        this.authenticationService.login({
            ...this.loginForm.value,
            rememberMe: this.rememberMe
        }).subscribe(
            () => {
                this.notificationService.dismiss();
                this.dialogRef.close();
                // Si une URL a été stockée par l'intercepteur authExpiredInterceptor avant de rediriger vers la dialog de login
                // Alors on redirige vers cette URL puis on efface l'URL stockée
                const redirect = this.stateStorageService.getUrl();
                if (redirect && redirect != "/login") {
                    this.stateStorageService.storeUrl(null);
                    this.router.navigate([redirect]);
                } else {
                    this.router.navigate(['']);
                }
            },
            (error: HttpErrorResponse) => {
                this.notificationService.dismiss();
                if (error && (error.status === 0 || error.status === 502 || error.status === 503 || error.status === 504)) {
                    // Service indisponible -> message général de l'application
                    return;
                }
                let message;
                if (error && error.status === 401) {
                    message = error.error.detail.replace('Les identifications sont erronées', 'Les identifiants sont erronés'); // Remplace le message de Spring ;-)
                } else {
                    message = 'Impossible de vous connecter. Merci de vérifier vos identifiants ou de réessayer ultérieurement';
                }
                this.notificationService.error(message);
            }
        );
    }

    requestResetPassword() {
        this.dialogRef.close();
        this.router.navigate(['/password-reset/init']);
    }
}
